import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { pathLanguage, loadTranslations } from "@/contexts/I18nContext";
import { captureFirstTouch } from "@/lib/attribution";

captureFirstTouch();

const root = ReactDOM.createRoot(document.getElementById("root"));
const render = (preloadedTranslations) =>
  root.render(
    <React.StrictMode>
      <App preloadedTranslations={preloadedTranslations} />
    </React.StrictMode>,
  );

// On a language landing page, keep the prerendered snapshot on screen until that
// language is loaded, instead of flashing English first.
const lang = pathLanguage();
if (lang) {
  loadTranslations(lang).then((t) => render(t ? { [lang]: t } : undefined), () => render());
} else {
  render();
}
